import { StyleSheet, Text, View } from 'react-native';
import React, { FC } from 'react';
import { Modal } from 'react-native';
import { Button } from '../../../components/Button';
import { STYLE_VARS } from '../../../constants/style-vars';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { COLORS, FONTS } from '../../../constants';

interface FeedbackPopupProps {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  isModalVisible: boolean;
}

const FeedbackPopup: FC<FeedbackPopupProps> = ({
  isModalVisible,
  setIsModalVisible,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <Modal visible={isModalVisible} animationType="fade" transparent={true}>
      <View style={styles.container}>
        <View style={styles.modalContainer}>
          <View
            style={{
              maxWidth: 240,
            }}
          >
            <Text
              style={{
                color: COLORS.GREEN,
                fontWeight: '500',
                fontFamily: FONTS.AvenirMedium,
                fontSize: isDesktop() ? 16 : undefined,
                marginBottom: isDesktop() ? 20 : 10,
                letterSpacing: 1,
                textTransform: 'uppercase',
                textAlign: 'center',
              }}
            >
              {
                'Your feedback has been sent successfully. We value your feedback and will respond accordingly. Thanks for your continued support with KCC.'
              }
            </Text>
          </View>
          <View
            style={{
              flexDirection: 'row',
              gap: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Button
              text="OK"
              style={[STYLE_VARS.blueButton, { flex: 1 }]}
              onPress={setIsModalVisible.bind(null, false)}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default FeedbackPopup;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 40,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContainer: {
    padding: 30,
    borderRadius: 20,
    backgroundColor: 'white', // Màu nền của modal (trong suốt)
  },
});
